import { MotifIcon, MotifProgressLoader } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import ClaimDetailsHeader from "./components/ClaimDetailsHeader";
import ClaimDetailsContent from "./ClaimDetailsContent";
import { useLocation, useParams } from "react-router-dom";
import { isEmpty } from "@/utility/common";
import ClaimItemCreate from "./ClaimItemCreate";
import { useSearchParams } from "react-router-dom";
import {
  useGetclaimStageAndDocumentApiDataQuery,
  useGetClaimStatusApiDataQuery,
  useGetClaimSummaryViewApiDataQuery,
} from "@/services/claimSummary/caseSummaryReducer";
import { TabComponent } from "./components/tabComponent";
import { useGetClaimItemDetailsQuery } from "@/services/claimDetail/claimDetailReducer";
import { useTranslation } from "react-i18next";
import { useCase } from "@/features/case/use-case";
import { ActiveTabsOrder } from "@/menuData";
import { dateFunc } from "@/components/Functions/dateFunc";
export default function ClaimDetails() {
  const { t } = useTranslation();
  const { claimItemId, caseId } = useParams();
  const [searchParams] = useSearchParams();
  const caseData = useCase();
  let claimId = searchParams.get("claimId");
  let creditorId = searchParams.get("creditorId");
  const creditorName = searchParams.get("creditorName");
  const navId = searchParams.get("navId");
  const navigatedFrom = searchParams.get("navigatedFrom");
  const paymentReference = searchParams.get("paymentReference");
  const updatedOn = searchParams.get("updatedOn");
  const { data, isLoading } = useGetClaimSummaryViewApiDataQuery(claimId);
  const { data: claimStageData } =
    useGetclaimStageAndDocumentApiDataQuery(claimId);
  const { data: getClaimStatus } = useGetClaimStatusApiDataQuery(
    claimStageData?.definitionIds.claimStatusDefinitionId,
    { skip: !claimStageData }
  );
  const { data: claimItem } = useGetClaimItemDetailsQuery({
    claimItemId: claimItemId,
    caseId: caseId,
  });
  let location = useLocation();
  let state = location.state;
  const headerparam = {
    claimId: "-",
    creditorName: "-",
    updatedOn: "-",
    claimItemId: "-",
    claimReference: "-",
    claimRefId: "-",
    creditorId: "",
    abbreviation: "",
  };
  if (!isEmpty(claimItemId)) {
    headerparam.claimId = claimId || data?.claimSummary?.claimId || "";
    headerparam.creditorName =
      creditorName || data?.claimSummary?.creditorName || "";
    headerparam.updatedOn =
      updatedOn ||
      dateFunc(data?.claimSummary?.updatedOn).formattedDateOnly ||
      "";
    headerparam.claimItemId = claimItemId || "";
    headerparam.claimReference = claimItem?.claimItemReference || "";
    headerparam.claimRefId =
      searchParams.get("claimReference") ||
      data?.claimSummary?.claimReference ||
      "";
    headerparam.creditorId = creditorId ? creditorId : "";
    headerparam.abbreviation = caseData?.abbreviation || "";
  } else {
    claimId = state?.claimId;
  }
  const renderComponent = !isEmpty(claimItemId) ? (
    <ClaimDetailsContent
      claimItemId={claimItemId || ""}
      claimId={claimId === null ? "" : claimId}
      getClaimItemstatus={getClaimStatus?.isResolveStatus ? true : false}
      claimStagePosition={claimStageData?.instanceData?.position}
    />
  ) : (
    <ClaimItemCreate claimId={claimId === null ? "" : claimId} />
  );
  // if(debtorId){
  //   navigate(`/case/${caseId}/debtor/${debtorId}/claim/${response}`)
  // }
  // else if(CreditorID){
  //   navigate(`/case/${caseId}/creditor/${CreditorID}/claim/${response}`)
  // }
  function handleRountingBasedonPreviosTab() {
    if (navigatedFrom === "creditor") {
      return `/case/${caseId}/creditor/${navId}/claim/${claimId}`;
    } else if (navigatedFrom === "debtor") {
      return `/case/${caseId}/debtor/${navId}/claim/${claimId}`;
    } else if (navigatedFrom === "paymentGrid") {
      return `/case/${caseId}/payment/${navId}`;
    } else if (navigatedFrom === "creditorDistribution") {
      return `/case/${caseId}/payment/${navId}?creditorId=${creditorId}&creditorName=${creditorName}`;
    } else {
      return `/case/${caseId}/claim/${claimId}?claimId=${claimId}`;
    }
  }

  const breadcrumbItems = !isEmpty(claimItemId)
    ? [
        {
          text: caseData?.caseName,
          url: `/case/${caseId}?activeTab=${
            navigatedFrom === "paymentGrid"
              ? ActiveTabsOrder.PAYMENT
              : navigatedFrom === "creditorDistribution"
              ? ActiveTabsOrder.CREDITOR
              : ActiveTabsOrder.CLAIM
          }`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          text:
            navigatedFrom === "paymentGrid" ||
            navigatedFrom === "creditorDistribution"
              ? paymentReference
              : searchParams?.get("claimReference") || "",
          url: handleRountingBasedonPreviosTab(),
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          text: claimItem?.claimItemReference || "",
          url: state?.paymentId
            ? `/case/${caseId}/payment/${state?.paymentId}`
            : `/case/${caseId}/claim/${claimId}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
          disabled: true,
        },
      ]
    : [
        {
          text: caseData?.caseName,
          url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          text: searchParams?.get("claimReference") || "",
          url:
            navigatedFrom === "creditor" && navId
              ? `/case/${caseId}/creditor/${navId}/claim/${claimId}`
              : navigatedFrom === "debtor" && navId
              ? `/case/${caseId}/debtor/${navId}/claim/${claimId}`
              : `/case/${caseId}/claim/${claimId}?claimId=${claimId}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          text: t("pages.claims.claimIteamsTab.addButton"),
          url: `/case/${caseId}/claim/${claimId}?claimId=${claimId}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
          disabled: true,
        },
      ];

  const tabPanelData = {
    title: [
      t("pages.claims.claimItemTabPannel.summary"),
      t("pages.claims.claimItemTabPannel.classification"),
    ],
    content: [
      <>{renderComponent}</>,
      <div>{t("pages.claims.claimItemTabPannel.classification")}</div>,
    ],
  };
  if (isLoading) {
    return <MotifProgressLoader></MotifProgressLoader>;
  }
  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />

      <ClaimDetailsHeader create={true} headerparam={headerparam} />
      <div className="ccwp_table_wrapper ccwp_table_dropdown_wrapper">
        {/* <TabPanel data={tabPanelData} /> */}
        <TabComponent
          tabPanelData={tabPanelData}
          renderComponent={renderComponent}
        />
      </div>
    </>
  );
}
